<template>
  <div class="region-select">
    <div class="modal region-select-modal">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <p class="subtitle">
            {{ $t("gps.where-are-you") }}
          </p>
          <div class="geo">
            <div v-if="!country" class="country">
              <div @click="country = 'Thailand'" style="margin-bottom: 10px">
                <p class="has-text-dark">{{ translateGeo("Thailand") }}</p>
                <flag iso="th" :squared="false" />
              </div>
              <div @click="country = 'Myanmar'" style="margin-bottom: 10px">
                <p class="has-text-dark">{{ translateGeo("Myanmar") }}</p>
                <flag iso="mm" :squared="false" />
              </div>
              <div @click="country = 'Portugal'">
                <p class="has-text-dark">{{ translateGeo("Portugal") }}</p>
                <flag iso="pt" :squared="false" />
              </div>
            </div>
            <div v-else>
              <div
                @click="resetCountry"
                style="margin-bottom: 10px; font-size: 1.3em"
              >
                <div style="float: left; width: 0; margin-top: 16px">
                  <span class="button is-light" style="padding: 12px">
                    <i class="fa fa-chevron-left fa-lg has-text-grey" />
                  </span>
                </div>
                <flag v-if="country === 'Thailand'" iso="th" :squared="false" />
                <flag v-if="country === 'Myanmar'" iso="mm" :squared="false" />
                <flag v-if="country === 'Portugal'" iso="pt" :squared="false" />
              </div>
              <div v-for="c in cities" :key="c" class="cities">
                <span class="button" @click="chooseCity(c)">{{
                  translateGeo(c)
                }}</span>
              </div>
            </div>
          </div>
          <br />
          <p v-if="unknownGPSLocation" class="has-text-grey">
            <i class="fa fa-spinner fa-spin" />
            &nbsp;{{ $t("gps.detecting-gps") }}
          </p>
          <p v-else @click="useDetectedRegion">
            <span class="button is-white">{{ $t("gps.gps-detected") }}</span>
            <span class="button is-link is-outlined">{{
              translateGeo(detectedRegion)
            }}</span>
          </p>
        </section>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      ></button>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import geo from "@/geo";

export default {
  name: "RegionSelect",
  components: {},
  data() {
    return {
      // active: false,
      detectedRegion: null,
      country: null,
      // country: "Thailand", //null, // after we have multiple countries
      geos: {
        Thailand: ["Bangkok", "Chiang Mai", "Hat Yai", "Songkhla"],
        Myanmar: ["Bagan", "Mandalay", "Pakokku", "Tachileik", "Yangon"], // later add more countries here
        Portugal: ["Lisbon"],
      },
      nextPath: null, //"tuktuk", // path to navigate too after have location
    };
  },
  mounted() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === "setUserState") {
        this.detectedRegion = geo.getRegion(this.$store.state.userState);
      }
    });
    EventBus.$on("OPEN_REGION_MODAL", (nextPath) => {
      this.nextPath = nextPath; // optionally passed next path, if null won't navigate
    });
  },
  computed: {
    unknownGPSLocation() {
      return !this.$store.getters.getUserLocation;
    },
    cities() {
      return this.geos[this.country];
    },
  },
  methods: {
    closeModal() {
      // this.country = null;
      this.country = "Thailand";
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    translateGeo(name) {
      if (!name) return;
      var lowerDash = name.replace(/\s+/g, "-").toLowerCase();
      return this.$t(`geo.${lowerDash}`);
    },
    resetCountry() {
      this.country = null;
      // this.country = "Thailand"; // for now only show Thailand
    },
    useDetectedRegion() {
      this.updateDataForSelectedRegion();
    },
    chooseCity(city) {
      // this.city = geo.getRegion(this.$store.state.userState); // Chiang Mai, Bangkok, etc.
      var coords = null; // could set default coords here
      switch (city) {
        case "Bangkok":
          coords = { lat: 13.7321, lon: 100.5696 };
          break;
        case "Chiang Mai":
          coords = { lat: 18.796143, lon: 98.979263 };
          break;
        case "Bagan":
          coords = { lat: 21.20129, lon: 94.908509 };
          break;
        case "Pakokku":
          coords = { lat: 21.33562, lon: 95.0171976 };
          break;
        case "Singapore":
          coords = { lat: 1.29027, lon: 103.851959 };
          break;
        case "Lisbon":
          coords = { lat: 38.71709, lon: -9.13926 };
          break;
        default:
          coords = { lat: 18.796143, lon: 98.979263 }; // Chiang Mai default
      }
      this.$store.commit("setUserState", coords); // your fakeLocation
      this.$store.commit("setRegion", city);
      this.updateDataForSelectedRegion();
    },
    updateDataForSelectedRegion() {
      this.updateAllWorkflows();
      var loader = this.loadingDots("lightgreen");
      setTimeout(() => {
        loader.hide();
        if (this.nextPath) this.$router.push(this.nextPath);
        this.closeModal();
      }, 2000);
    },
  },
};
</script>

<style scoped>
.subtitle {
  /* text-align: left; */
  font-size: 1.3em;
  font-weight: 450;
  margin-bottom: 20px;
}
.modal-card-body {
  width: 95vw;
  max-width: 500px;
  margin: 0 auto;
  border-radius: 25px;
}
.country {
  font-size: 1.3em;
}
.geo {
  background-color: whitesmoke;
  border-radius: 25px;
  padding: 10px;
}
/* .flag {
  -webkit-filter: drop-shadow(2px 2px 2px #666);
  filter: drop-shadow(2px 2px 2px #666);
} */
.flag-icon {
  filter: drop-shadow(1px 1px 3px #777);
  font-size: 2.5em;
  border-radius: 6px;
  margin-top: 6px;
}
.cities {
  padding-bottom: 10px;
}
.cities .button {
  width: 50%;
}
</style>